import React from "react";

const facilities = [
  {
    id: 1,
    title: "Discount at Golf View Restaurant",
    desc: "Members can avail discount at the Golf View Restaurant, making dining more enjoyable and affordable.",
  },
  {
    id: 2,
    title: "Guest Room Facilities",
    desc: "Members have access to guest room facilities for a comfortable stay within the club premises.",
  },
  {
    id: 3,
    title: "Golf without Fair Fee",
    desc: "Members can enjoy playing golf without a fair and reduced fee, encouraging more participation.",
  },
  {
    id: 4,
    title: "Discount at Pro Shop",
    desc: "Members can avail discounts at the Pro Shop on golfing essentials and accessories.",
  },
];

const FacilitiesForMembers = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      {/* Page Title */}
      <h1 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-green-700">
        Facilities for Members
      </h1>

      {/* Timeline */}
      <div className="relative max-w-3xl mx-auto border-l border-green-300">
        {facilities.map((facility) => (
          <div key={facility.id} className="mb-10 ml-6">
            {/* Circle marker */}
            <span className="absolute -left-3 flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 bg-green-600 rounded-full ring-4 ring-white text-white text-xs sm:text-sm font-bold">
              {facility.id}
            </span>

            {/* Content Card */}
            <div className="p-4 sm:p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition">
              <h2 className="text-lg sm:text-xl font-semibold text-green-700">
                {facility.title}
              </h2>
              <p className="mt-2 text-sm sm:text-base text-gray-700 leading-relaxed">
                {facility.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FacilitiesForMembers;
